import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ModalController, NavController } from '@ionic/angular';
import { BilletService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ModalTokenComponent } from 'src/app/views/themes/sentinel/modals/modal-token/modal-token.component';

import { ModalAlertComponent } from './../../../../../modals/modal-alert/modal-alert.component';

@Component({
  selector: 'app-liquidation',
  templateUrl: './liquidation.page.html',
  styleUrls: ['./liquidation.page.scss'],
})
export class LiquidationPage implements OnInit, OnDestroy {

  public userProfile: UserInfoProfile;
  public form: FormGroup;

  private destroy$: Subject<null> = new Subject();

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  private readonly OPERATION: string = '916';

  constructor(
    protected userInfoService: UserInfoService,
    private loadingService: LoadingService,
    private modalController: ModalController,
    private service: BilletService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    private navCtrl: NavController
  ) { }

  public ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.loadUser();
    this.form = this.service.createFormLiquidation();
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public f(control: string): AbstractControl {
    return this.form.get(control);
  }

  public async confirm() {
    this.f('uuidWhiteLabel').patchValue(this.userProfile.uuidWhiteLabel);

    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION
      },
    });

    modalToken.onDidDismiss().then((data) => {
      this.loadingService.show();
      if (data['data']) {
        this.f('codeAuthorization').patchValue(data['role']);
        this.processRequest();
      }
      this.loadingService.hide();
    });

    return await modalToken.present();
  }

  private processRequest() {
    this.service
      .liquidation(this.userProfile.uuidAccount, this.form.value)
      .pipe(
        takeUntil(this.destroy$),
        tap((res) => {
          const response = res;

          if (response !== null || response !== undefined) {
            if (response.isExecuted === true) {
              this.notification('success', 'CASH_OUT.LIQUIDATION.MESSAGES.SUCCESS');
              return;
            } else (response.isExecuted === false); {
              this.notification('warning-circle', response.message);
            }
          } else {
            this.notification('warning-circle', 'CASH_OUT.LIQUIDATION.MESSAGES.FAILED');
          }

          this.form = this.service.createFormLiquidation();
          this.loadingService.hide();
        }),
        catchError((_) => {
          this.notification('warning-circle', 'CASH_OUT.LIQUIDATION.MESSAGES.FAILED');
          this.form = this.service.createFormLiquidation();
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
  }

  private async notification(status: string, message: string, confirmation?: boolean) {
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        confirmBtn: 'CARDS.CARD_MANAGER.CARDS_LOCK.CLOSE',
        confirmation: confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });

    return await modalSuccess.present();
  }

  private loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }
}
